// extracted by mini-css-extract-plugin
export default {"button":"SelectionActionButton_button__rfhpESRf","icon":"SelectionActionButton_icon__UclWVHQ5","text":"SelectionActionButton_text__b1YcnKNt"};